<ng-container *ngIf="question">
  <ng-container
    *ngIf="question.field_type === FieldTypes.DROPDOWN; else nonDropdown">
    <ng-container *ngIf="viewState === viewStates.PREVIEW">
      <div class="dropdown-wrapper">
        <div class="arrow"></div>
        <ng-container *ngFor="let option of question.answerOptions">
          <div class="d-flex align-items-center form-check mb-3 ps-0">
            <label
              class="form-check-label xms-3 fs-14"
              [attr.for]="'option-' + question.id + '-' + option.id"
              [ngStyle]="{
                pointerEvents: isInputInteractive ? 'auto' : 'none',
                cursor: isInputInteractive ? 'pointer' : 'default'
              }">
              {{ option.answer }}
            </label>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="viewState === viewStates.EDIT">
      <ng-select
        #formSelect
        [labelForId]="question.id"
        [items]="question.answerOptions"
        bindLabel="answer"
        [clearable]="false"
        [(ngModel)]="selectedOption"
        (change)="handleDropdownSelect($event)"
        [ngStyle]="{ minWidth: '400px' }"
        placeholder="Select an option" />
    </ng-container>
    <ng-container
      *ngIf="
        viewState === viewStates.GRADED || viewState === viewStates.SUBMITTED
      ">
      <ng-container *ngFor="let option of question.answerOptions">
        <div class="d-flex align-items-center form-check mb-3">
          <ng-container
            *ngIf="answerOptionIds.includes(option.id); else wrongAnswer">
            <img
              class="svg-icon"
              style="float: left; margin-left: -1.5em"
              src="/assets/proforms/icon-dropdown-reverse.svg"
              alt="Dropdown Icon" />
          </ng-container>
          <ng-template #wrongAnswer>
            <img
              class="svg-icon"
              style="float: left; margin-left: -1.5em; opacity: 0.2"
              src="/assets/proforms/icon-dropdown-reverse.svg"
              alt="Dropdown Icon" />
          </ng-template>
          <label
            class="form-check-label ms-3 fs-14"
            [attr.for]="'option-' + question.id + '-' + option.id">
            {{ option.answer }}
          </label>
          <ng-container
            *ngIf="
              viewState === viewStates.GRADED &&
              hasCorrectAnswers &&
              showAnswers
            ">
            <!-- User selected this option -->
            <ng-container *ngIf="answerOptionIds.includes(option.id)">
              <!-- Selected but incorrect -->
              <i
                *ngIf="!option.is_correct"
                class="bi bi-x color-danger fs-18 bold-icon ms-2"
                title="Your answer - Incorrect"></i>

              <!-- Selected and correct -->
              <i
                *ngIf="option.is_correct"
                class="bi bi-check color-success fs-18 bold-icon ms-2"
                title="Your answer - Correct"></i>
            </ng-container>

            <!-- User did NOT select this option, but it's correct -->
            <div
              class="form-check-label ms-2 fs-14 fw-bold"
              *ngIf="option.is_correct">
              Correct Answer
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #nonDropdown>
    <ng-container *ngFor="let option of question.answerOptions">
      <div class="d-flex align-items-center form-check mb-3">
        <input
          [id]="'option-' + question.id + '-' + option.id"
          [type]="question.field_type"
          [checked]="answerOptionIds.includes(option.id)"
          [name]="question.field_type + '-' + question.id"
          class="form-check-input"
          [ngStyle]="{
            pointerEvents: isInputInteractive ? 'auto' : 'none',
            opacity: 1,
            cursor: isInputInteractive ? 'pointer' : 'default'
          }"
          [attr.tabindex]="isInputInteractive ? 0 : -1"
          (change)="isInputInteractive && onOptionChange(option.id, $event)" />

        <label
          class="form-check-label ms-3 fs-14"
          [attr.for]="'option-' + question.id + '-' + option.id"
          [ngStyle]="{
            pointerEvents: isInputInteractive ? 'auto' : 'none',
            cursor: isInputInteractive ? 'pointer' : 'default'
          }">
          {{ option.answer }}
        </label>
        <ng-container
          *ngIf="
            viewState === viewStates.GRADED && hasCorrectAnswers && showAnswers
          ">
          <!-- User selected this option -->
          <ng-container *ngIf="answerOptionIds.includes(option.id)">
            <!-- Selected but incorrect -->
            <i
              *ngIf="!option.is_correct"
              class="bi bi-x color-danger fs-18 bold-icon ms-2"
              title="Your answer - Incorrect"></i>

            <!-- Selected and correct -->
            <i
              *ngIf="option.is_correct"
              class="bi bi-check color-success fs-18 bold-icon ms-2"
              title="Your answer - Correct"></i>
          </ng-container>

          <!-- User did NOT select this option, but it's correct -->
          <div
            class="form-check-label ms-2 fs-14 fw-bold"
            *ngIf="option.is_correct">
            Correct Answer
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-template>
</ng-container>
